import { FirearmPoolService } from '../model/firearm-pool.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { FirearmPool } from 'assets-model';
import { Observable } from 'rxjs';


export class FirearmPoolDataSource extends CrudDataSource<FirearmPool> {

  constructor(private service: FirearmPoolService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<FirearmPool>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


